import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { FileErrorMessages } from '../enums/file-error-messages.enum';

export const FIVE_MEGABYTES = 5;
export const VALID_FILE_TYPES = ['image/png', 'image/jpeg'];
export const PDF_TYPE = ['application/pdf'];
export const DECIMAL = 10;
export const FRACTION_DIGITS = 4;
export const BYTES = 1024;

export const fileUploadValidator =
  (): ValidatorFn =>
  (control: AbstractControl<File | null>): ValidationErrors | null => {
    if (!control.value?.size) {
      return null;
    }

    const filesize = parseInt(
      (control.value?.size / BYTES / BYTES).toFixed(FRACTION_DIGITS),
      DECIMAL
    );
    if (filesize > FIVE_MEGABYTES) {
      control.setValue(null);
      return { filesize: FileErrorMessages.FILE_SIZE_ERROR };
    }

    const fileTypeIsValid = VALID_FILE_TYPES.includes(control.value?.type);
    if (!fileTypeIsValid) {
      control.setValue(null);
      return { fileType: FileErrorMessages.FILE_TYPE_ERROR };
    }

    return null;
  };
